/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import video_home from '../../../Recursos/video_home.mp4'
import img_home from '../../../Recursos/fondo_video.png'
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <video width={'100%'} height={ sCell ? 600 : 720}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       // backgroundImage: `url(${img_fondo})`,
                       backgroundPosition: 'center',
                       backgroundSize: 'cover'
                   }}
                   id="background-video" autoPlay loop muted poster={img_home}>
                {video_home &&
                    <source src={video_home} type="video/mp4"/>
                }
            </video>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: sCell ? -52 : -62, zIndex: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography
                                    sx={{fontSize: sCell ? 40 : 56, color: '#fff', fontWeight: 800, lineHeight: 1.1}}>Tú
                                    puente
                                    al nuevo comercio
                                    <br/>
                                    <span
                                        style={{
                                            backgroundClip: 'text',
                                            backgroundImage: 'linear-gradient(89deg, #1F7DFE 14.3%, #00FFE1 57.84%)',
                                            color: 'transparent'
                                        }}>
                                    inteligente

                                </span>
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Typography sx={{color: '#fff', fontSize: 15}}>Conectamos tecnología blockchain, activos
                                    físicos y logística global para
                                    ofrecer una forma más segura, eficiente e inteligente de mover valor en el
                                    mundo.</Typography>
                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Portada